module.exports = __webpack_public_path__ + "static/bg-microsoft-574fae79455948cb670acb3027948236.webp";